<template>
  <ProductReviews v-if="product && tsProduct" v-bind="{ product, tsProduct }" />
  <ProductReviewsWithProvider v-else-if="shopifyHandle" v-bind="{ shopifyHandle }" />
</template>

<script setup lang="ts">
import ProductReviews from './ProductReviews.vue';
import ProductReviewsWithProvider from './ProductReviewsWithProvider.vue';

defineProps({
  shopifyHandle: {
    type: String,
    default: null,
  },
  product: {
    type: Object,
    default: null,
  },
  tsProduct: {
    type: Object,
    default: () => null,
  },
});
</script>
